import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { BsFillBellFill } from "react-icons/bs";
import { MdDoubleArrow } from 'react-icons/md';
import { useDispatch ,useSelector } from 'react-redux';
import { fetchNotification } from '../../redux/Slice/carSlice';
import { formatTimeAgoOrDateTime } from '../../utils';


const Notification = () => {
    const {userDetail} = useSelector((state) => state?.auth);
const [notificationData, setNotificationData] = useState([]);
const dispatch=useDispatch();
console.log('userDetail', userDetail?.data._id)
    useEffect(()=>{
        if( userDetail?.data._id)
fetchData()
    },[])
    const fetchData=async ()=>{

        let resp = await dispatch(fetchNotification({userId:userDetail?.data?._id}));
        setNotificationData(resp?.payload)
        console.log('resp?.payload', resp?.payload)
    }
    console.log(notificationData,"notificationData")

    return (
        <div>
            <List>
                <div className='d-flex align-items-center p-4' >
                    <h3 className='d-flex flex-row  accentColor align-items-center' >
                        <span className='lh-0' ><MdDoubleArrow /></span><span className='font' >Notifications</span>
                    </h3>
                </div>
                {notificationData?.map((notify,index)=>(
                    <>
                    <ListItem key={index}>
                    <ListItemButton>
                        <ListItemIcon>
                            <div className='notif-bell' >
                                <BsFillBellFill />
                            </div>
                        </ListItemIcon>
                        <div className='d-flex flex-column' >
                            <h6 className='mb-0 secondaryColor text-capitalize'  >{notify?.type}</h6>
                            <p className='notif-text' >{notify?.message}</p>
                            <p className='text-secondary notif-time' > {formatTimeAgoOrDateTime(notify?.createdAt)}</p>
                        </div>
                    </ListItemButton>
                </ListItem>
                <hr className='my-0' />
                    </>
                ))}
                {/* <ListItem>
                    <ListItemButton>
                        <ListItemIcon>
                            <div className='notif-bell' >
                                <BsFillBellFill />
                            </div>
                        </ListItemIcon>
                        <div className='d-flex flex-column' >
                            <h6 className='mb-0 secondaryColor'  >40% off today</h6>
                            <p className='notif-text' >Hurry Up! Don't sit at home today. Best car rental deal today.</p>
                            <p className='text-secondary notif-time' >3 min ago</p>
                        </div>
                    </ListItemButton>
                </ListItem>
                <hr className='my-0' />
                <ListItem>
                    <ListItemButton>
                        <ListItemIcon>
                            <div className='notif-bell' >
                                <BsFillBellFill />
                            </div>
                        </ListItemIcon>
                        <div className='d-flex flex-column' >
                            <h6 className='mb-0 secondaryColor'  >Booking Successful</h6>
                            <p className='notif-text' >Congratulation!. your Audi A8 L booked successfully.</p>
                            <p className='text-secondary notif-time' >3 min ago</p>
                        </div>
                    </ListItemButton>
                </ListItem> */}
                <hr className='my-0' />
            </List>
        </div>
    )
}

export default Notification
